import React, { useState } from "react";
import styled from "styled-components";
import { authenticate } from './authenticate';
import userpool from './userpool'
import { useNavigate , Link} from 'react-router-dom';
import PasswordModal from "./PasswordModal";
import { PriceContext } from './context';
import { useContext } from 'react';
const Container = styled.div`
display:flex;
flex-grow:1;
flex-direction:column;
margin: 0 auto;
padding: 20px;
border-radius: 5px;
align-items: center;
height:100%
width:100%;
z-index:100;
box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);


  @media (max-width: 600px) {

    margin:auto 0;
  }

  @media (min-width: 300px) {

    margin:auto;
  }
`;
const Pcontainer = styled.div`
  height: 100%;
  display:flex;
  justify-content:center;
`;
const LoginContainer = styled.div`
  display:flex;
  flex-grow:1;

  align-content:center;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
`;

const FormGroup = styled.div`
  margin-bottom: 15px;
`;

const Label = styled.label`
  display: block;
  margin-bottom: 5px;
`;

const Input = styled.input`
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
`;
const CenteredH1 = styled.h1`
  text-align: center;
  margin-bottom: 5px;

`;

const Button = styled.button`
  width: 50%;
  padding: 10px;
  background-color: #007bff;
  justify-self:center;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  &:hover {
    background-color: #0056b3;
  }
`;

function Login({navigate}) {
    const [modelTrigger, SetModelTrigger] = useState(false);
  
  const Navigate = useNavigate();
  const {userHasAuthenticated, setEmailCon} = useContext(PriceContext);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailErr, setEmailErr] = useState('');
  const [passwordErr, setPasswordErr] = useState('');
  const [loginErr,setLoginErr]=useState('');
  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle login logic here
    authenticate(email,password)

    .then((data)=>{
      setLoginErr('');
      userHasAuthenticated(true)
      setEmailCon(email)
      navigate('/account')
    },(err)=>{
            SetModelTrigger(!modelTrigger)

      setLoginErr(err.message)
    })
    .catch()
  };

  return (
  <Pcontainer>
    <Container>      
      <PasswordModal trigger={modelTrigger}/>

      <form onSubmit={handleSubmit}>
    <CenteredH1>Login</CenteredH1>

          <Input
            type="email"
            id="email"
            value={email}
            placeholder="email"
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <Input
            type="password"
            id="password"
            placeholder="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        <Button type="submit">Login</Button>
      </form>

     <Link to ='/forgot'>
     <p> Forgot Your Password</p>
     </Link> 
      </Container>

    </Pcontainer>

  );
}

export default Login;